/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedLegalRouteImport } from './routes/_authed/legal'
import { Route as AuthedReleasesRouteImport } from './routes/_authed/releases'
import { Route as AuthedSiteRouteImport } from './routes/_authed/site'
import { Route as AuthedAnalyticsIndexRouteImport } from './routes/_authed/analytics/index'
import { Route as AuthedAssetsIndexRouteImport } from './routes/_authed/assets/index'
import { Route as AuthedAssetsJobsRouteImport } from './routes/_authed/assets/jobs'
import { Route as AuthedAuditIndexRouteImport } from './routes/_authed/audit/index'
import { Route as AuthedAvatarsIndexRouteImport } from './routes/_authed/avatars/index'
import { Route as AuthedCategoriesIndexRouteImport } from './routes/_authed/categories/index'
import { Route as AuthedFlagsIndexRouteImport } from './routes/_authed/flags/index'
import { Route as AuthedGroupsIndexRouteImport } from './routes/_authed/groups/index'
import { Route as AuthedModerationIndexRouteImport } from './routes/_authed/moderation/index'
import { Route as AuthedParametersIndexRouteImport } from './routes/_authed/parameters/index'
import { Route as AuthedSystemIndexRouteImport } from './routes/_authed/system/index'
import { Route as AuthedUsersIndexRouteImport } from './routes/_authed/users/index'
import { Route as AuthedUsersUserIdRouteImport } from './routes/_authed/users/$userId'
import { Route as AuthedWorldsIndexRouteImport } from './routes/_authed/worlds/index'
import { Route as AuthedWorldsSlugRouteImport } from './routes/_authed/worlds/$slug'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLegalRoute = AuthedLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReleasesRoute = AuthedReleasesRouteImport.update({
  id: '/releases',
  path: '/releases',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSiteRoute = AuthedSiteRouteImport.update({
  id: '/site',
  path: '/site',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsIndexRoute = AuthedAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAssetsIndexRoute = AuthedAssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAssetsJobsRoute = AuthedAssetsJobsRouteImport.update({
  id: '/assets/jobs',
  path: '/assets/jobs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditIndexRoute = AuthedAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAvatarsIndexRoute = AuthedAvatarsIndexRouteImport.update({
  id: '/avatars/',
  path: '/avatars/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCategoriesIndexRoute = AuthedCategoriesIndexRouteImport.update({
  id: '/categories/',
  path: '/categories/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFlagsIndexRoute = AuthedFlagsIndexRouteImport.update({
  id: '/flags/',
  path: '/flags/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGroupsIndexRoute = AuthedGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedModerationIndexRoute = AuthedModerationIndexRouteImport.update({
  id: '/moderation/',
  path: '/moderation/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedParametersIndexRoute = AuthedParametersIndexRouteImport.update({
  id: '/parameters/',
  path: '/parameters/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSystemIndexRoute = AuthedSystemIndexRouteImport.update({
  id: '/system/',
  path: '/system/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersIndexRoute = AuthedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersUserIdRoute = AuthedUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWorldsIndexRoute = AuthedWorldsIndexRouteImport.update({
  id: '/worlds/',
  path: '/worlds/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWorldsSlugRoute = AuthedWorldsSlugRouteImport.update({
  id: '/worlds/$slug',
  path: '/worlds/$slug',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/legal': typeof AuthedLegalRoute
  '/releases': typeof AuthedReleasesRoute
  '/site': typeof AuthedSiteRoute
  '/assets/jobs': typeof AuthedAssetsJobsRoute
  '/users/$userId': typeof AuthedUsersUserIdRoute
  '/worlds/$slug': typeof AuthedWorldsSlugRoute
  '/analytics/': typeof AuthedAnalyticsIndexRoute
  '/assets/': typeof AuthedAssetsIndexRoute
  '/audit/': typeof AuthedAuditIndexRoute
  '/avatars/': typeof AuthedAvatarsIndexRoute
  '/categories/': typeof AuthedCategoriesIndexRoute
  '/flags/': typeof AuthedFlagsIndexRoute
  '/groups/': typeof AuthedGroupsIndexRoute
  '/moderation/': typeof AuthedModerationIndexRoute
  '/parameters/': typeof AuthedParametersIndexRoute
  '/system/': typeof AuthedSystemIndexRoute
  '/users/': typeof AuthedUsersIndexRoute
  '/worlds/': typeof AuthedWorldsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/legal': typeof AuthedLegalRoute
  '/releases': typeof AuthedReleasesRoute
  '/site': typeof AuthedSiteRoute
  '/': typeof AuthedIndexRoute
  '/assets/jobs': typeof AuthedAssetsJobsRoute
  '/users/$userId': typeof AuthedUsersUserIdRoute
  '/worlds/$slug': typeof AuthedWorldsSlugRoute
  '/analytics': typeof AuthedAnalyticsIndexRoute
  '/assets': typeof AuthedAssetsIndexRoute
  '/audit': typeof AuthedAuditIndexRoute
  '/avatars': typeof AuthedAvatarsIndexRoute
  '/categories': typeof AuthedCategoriesIndexRoute
  '/flags': typeof AuthedFlagsIndexRoute
  '/groups': typeof AuthedGroupsIndexRoute
  '/moderation': typeof AuthedModerationIndexRoute
  '/parameters': typeof AuthedParametersIndexRoute
  '/system': typeof AuthedSystemIndexRoute
  '/users': typeof AuthedUsersIndexRoute
  '/worlds': typeof AuthedWorldsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/legal': typeof AuthedLegalRoute
  '/_authed/releases': typeof AuthedReleasesRoute
  '/_authed/site': typeof AuthedSiteRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/assets/jobs': typeof AuthedAssetsJobsRoute
  '/_authed/users/$userId': typeof AuthedUsersUserIdRoute
  '/_authed/worlds/$slug': typeof AuthedWorldsSlugRoute
  '/_authed/analytics/': typeof AuthedAnalyticsIndexRoute
  '/_authed/assets/': typeof AuthedAssetsIndexRoute
  '/_authed/audit/': typeof AuthedAuditIndexRoute
  '/_authed/avatars/': typeof AuthedAvatarsIndexRoute
  '/_authed/categories/': typeof AuthedCategoriesIndexRoute
  '/_authed/flags/': typeof AuthedFlagsIndexRoute
  '/_authed/groups/': typeof AuthedGroupsIndexRoute
  '/_authed/moderation/': typeof AuthedModerationIndexRoute
  '/_authed/parameters/': typeof AuthedParametersIndexRoute
  '/_authed/system/': typeof AuthedSystemIndexRoute
  '/_authed/users/': typeof AuthedUsersIndexRoute
  '/_authed/worlds/': typeof AuthedWorldsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/legal'
    | '/releases'
    | '/site'
    | '/assets/jobs'
    | '/users/$userId'
    | '/worlds/$slug'
    | '/analytics/'
    | '/assets/'
    | '/audit/'
    | '/avatars/'
    | '/categories/'
    | '/flags/'
    | '/groups/'
    | '/moderation/'
    | '/parameters/'
    | '/system/'
    | '/users/'
    | '/worlds/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/legal'
    | '/releases'
    | '/site'
    | '/'
    | '/assets/jobs'
    | '/users/$userId'
    | '/worlds/$slug'
    | '/analytics'
    | '/assets'
    | '/audit'
    | '/avatars'
    | '/categories'
    | '/flags'
    | '/groups'
    | '/moderation'
    | '/parameters'
    | '/system'
    | '/users'
    | '/worlds'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/legal'
    | '/_authed/releases'
    | '/_authed/site'
    | '/_authed/'
    | '/_authed/assets/jobs'
    | '/_authed/users/$userId'
    | '/_authed/worlds/$slug'
    | '/_authed/analytics/'
    | '/_authed/assets/'
    | '/_authed/audit/'
    | '/_authed/avatars/'
    | '/_authed/categories/'
    | '/_authed/flags/'
    | '/_authed/groups/'
    | '/_authed/moderation/'
    | '/_authed/parameters/'
    | '/_authed/system/'
    | '/_authed/users/'
    | '/_authed/worlds/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/legal': {
      id: '/_authed/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof AuthedLegalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/releases': {
      id: '/_authed/releases'
      path: '/releases'
      fullPath: '/releases'
      preLoaderRoute: typeof AuthedReleasesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/site': {
      id: '/_authed/site'
      path: '/site'
      fullPath: '/site'
      preLoaderRoute: typeof AuthedSiteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/': {
      id: '/_authed/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthedAnalyticsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/assets/': {
      id: '/_authed/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AuthedAssetsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/assets/jobs': {
      id: '/_authed/assets/jobs'
      path: '/assets/jobs'
      fullPath: '/assets/jobs'
      preLoaderRoute: typeof AuthedAssetsJobsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit/': {
      id: '/_authed/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthedAuditIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/avatars/': {
      id: '/_authed/avatars/'
      path: '/avatars'
      fullPath: '/avatars/'
      preLoaderRoute: typeof AuthedAvatarsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/categories/': {
      id: '/_authed/categories/'
      path: '/categories'
      fullPath: '/categories/'
      preLoaderRoute: typeof AuthedCategoriesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/flags/': {
      id: '/_authed/flags/'
      path: '/flags'
      fullPath: '/flags/'
      preLoaderRoute: typeof AuthedFlagsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/groups/': {
      id: '/_authed/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof AuthedGroupsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/moderation/': {
      id: '/_authed/moderation/'
      path: '/moderation'
      fullPath: '/moderation/'
      preLoaderRoute: typeof AuthedModerationIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/parameters/': {
      id: '/_authed/parameters/'
      path: '/parameters'
      fullPath: '/parameters/'
      preLoaderRoute: typeof AuthedParametersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/system/': {
      id: '/_authed/system/'
      path: '/system'
      fullPath: '/system/'
      preLoaderRoute: typeof AuthedSystemIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/': {
      id: '/_authed/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedUsersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/$userId': {
      id: '/_authed/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthedUsersUserIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/worlds/': {
      id: '/_authed/worlds/'
      path: '/worlds'
      fullPath: '/worlds/'
      preLoaderRoute: typeof AuthedWorldsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/worlds/$slug': {
      id: '/_authed/worlds/$slug'
      path: '/worlds/$slug'
      fullPath: '/worlds/$slug'
      preLoaderRoute: typeof AuthedWorldsSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedLegalRoute: typeof AuthedLegalRoute
  AuthedReleasesRoute: typeof AuthedReleasesRoute
  AuthedSiteRoute: typeof AuthedSiteRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAssetsJobsRoute: typeof AuthedAssetsJobsRoute
  AuthedUsersUserIdRoute: typeof AuthedUsersUserIdRoute
  AuthedWorldsSlugRoute: typeof AuthedWorldsSlugRoute
  AuthedAnalyticsIndexRoute: typeof AuthedAnalyticsIndexRoute
  AuthedAssetsIndexRoute: typeof AuthedAssetsIndexRoute
  AuthedAuditIndexRoute: typeof AuthedAuditIndexRoute
  AuthedAvatarsIndexRoute: typeof AuthedAvatarsIndexRoute
  AuthedCategoriesIndexRoute: typeof AuthedCategoriesIndexRoute
  AuthedFlagsIndexRoute: typeof AuthedFlagsIndexRoute
  AuthedGroupsIndexRoute: typeof AuthedGroupsIndexRoute
  AuthedModerationIndexRoute: typeof AuthedModerationIndexRoute
  AuthedParametersIndexRoute: typeof AuthedParametersIndexRoute
  AuthedSystemIndexRoute: typeof AuthedSystemIndexRoute
  AuthedUsersIndexRoute: typeof AuthedUsersIndexRoute
  AuthedWorldsIndexRoute: typeof AuthedWorldsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedLegalRoute: AuthedLegalRoute,
  AuthedReleasesRoute: AuthedReleasesRoute,
  AuthedSiteRoute: AuthedSiteRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAssetsJobsRoute: AuthedAssetsJobsRoute,
  AuthedUsersUserIdRoute: AuthedUsersUserIdRoute,
  AuthedWorldsSlugRoute: AuthedWorldsSlugRoute,
  AuthedAnalyticsIndexRoute: AuthedAnalyticsIndexRoute,
  AuthedAssetsIndexRoute: AuthedAssetsIndexRoute,
  AuthedAuditIndexRoute: AuthedAuditIndexRoute,
  AuthedAvatarsIndexRoute: AuthedAvatarsIndexRoute,
  AuthedCategoriesIndexRoute: AuthedCategoriesIndexRoute,
  AuthedFlagsIndexRoute: AuthedFlagsIndexRoute,
  AuthedGroupsIndexRoute: AuthedGroupsIndexRoute,
  AuthedModerationIndexRoute: AuthedModerationIndexRoute,
  AuthedParametersIndexRoute: AuthedParametersIndexRoute,
  AuthedSystemIndexRoute: AuthedSystemIndexRoute,
  AuthedUsersIndexRoute: AuthedUsersIndexRoute,
  AuthedWorldsIndexRoute: AuthedWorldsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
